var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsInformation = function SvgIconsInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.818a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364zm0 6.364c.466 0 .85.35.903.803l.006.106v5.454a.91.91 0 0 1-1.812.106l-.006-.106v-5.454a.91.91 0 0 1 .909-.91zm.01-3.637a.91.91 0 0 1 .105 1.813L12 8.364a.91.91 0 0 1-.106-1.812l.115-.007z"
  })));
};
export default SvgIconsInformation;